let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7ZpqL"), load("f1WN5"), load("6ZgMI"), load("bAbyV")]).then(() => parcelRequire('bHS4c'));